import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import { getRelatedTopics } from '@utils/topics';
import TopicRouting from './components/TopicRouting';
import GetStarted from './components/GetStarted';

const messages = defineMessages({
  'prospectus.about.routing.title': {
    id: 'prospectus.about.routing.title',
    defaultMessage: 'Browse related topics',
    description: 'title for related topic section',
  },
});

function AboutRouting({ primarySubject, intl }) {
  return (
    <div className="about-page-routing mt-lg-5">
      <div className="container mw-lg">
        <GetStarted primarySubject={primarySubject} />
        <TopicRouting
          title={intl.formatMessage(messages['prospectus.about.routing.title'])}
          relatedTopics={getRelatedTopics(primarySubject.slug, intl.locale)}
        />
      </div>
    </div>
  );
}

AboutRouting.propTypes = {
  primarySubject: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    numberOfCourses: PropTypes.number,
  }).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(AboutRouting);
